import React from 'react';

import { useTheme } from '@material-ui/core';

export const ClosestTaskWidgetIcon = () => {
  const theme = useTheme();

  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0H28C34.6274 0 40 5.37258 40 12V28C40 34.6274 34.6274 40 28 40H12C5.37258 40 0 34.6274 0 28V12Z"
        fill={theme.tokens.colors.accent.bg.blue}
      />
      <g clipPath="url(#clip0_2950_59936)">
        <rect
          width="24"
          height="24"
          transform="translate(8 8)"
          fill={theme.tokens.colors.accent.bg.blue}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 9.5C16.497 9.5 16.9 9.90294 16.9 10.4V11.0004C17.0797 11 17.2668 11 17.4616 11H22.5384C22.7332 11 22.9203 11 23.1 11.0004V10.4C23.1 9.90294 23.5029 9.5 24 9.5C24.497 9.5 24.9 9.90294 24.9 10.4V11.053C25.5278 11.1062 26.0828 11.2173 26.5976 11.4796C27.4255 11.9014 28.0986 12.5745 28.5204 13.4024C28.7866 13.9248 28.8971 14.4886 28.9493 15.1279C29 15.7483 29 16.5141 29 17.4616V22.5384C29 23.4859 29 24.2517 28.9493 24.8721C28.8971 25.5114 28.7866 26.0752 28.5204 26.5976C28.0986 27.4255 27.4255 28.0986 26.5976 28.5204C26.0752 28.7866 25.5114 28.8971 24.8721 28.9493C24.2517 29 23.4859 29 22.5384 29H17.4616C16.5141 29 15.7483 29 15.1279 28.9493C14.4886 28.8971 13.9248 28.7866 13.4024 28.5204C12.5745 28.0986 11.9014 27.4255 11.4796 26.5976C11.2134 26.0752 11.1029 25.5114 11.0507 24.8721C11 24.2517 11 23.4859 11 22.5384V17.4616C11 16.5141 11 15.7483 11.0507 15.1279C11.1029 14.4886 11.2134 13.9248 11.4796 13.4024C11.9014 12.5745 12.5745 11.9014 13.4024 11.4796C13.9172 11.2173 14.4722 11.1062 15.1 11.053V10.4C15.1 9.90294 15.5029 9.5 16 9.5ZM15.1 12.8612C14.6779 12.9069 14.4197 12.9814 14.2196 13.0834C13.7304 13.3327 13.3327 13.7304 13.0834 14.2196C12.9681 14.4459 12.8878 14.7465 12.8447 15.2745C12.8085 15.7178 12.8016 16.2652 12.8003 17H27.1997C27.1984 16.2652 27.1915 15.7178 27.1553 15.2745C27.1122 14.7465 27.0319 14.4459 26.9166 14.2196C26.6673 13.7304 26.2696 13.3327 25.7804 13.0834C25.5803 12.9814 25.3221 12.9069 24.9 12.8612V13.6C24.9 14.0971 24.497 14.5 24 14.5C23.5029 14.5 23.1 14.0971 23.1 13.6V12.8005C22.9129 12.8 22.7134 12.8 22.5 12.8H17.5C17.2865 12.8 17.087 12.8 16.9 12.8005V13.6C16.9 14.0971 16.497 14.5 16 14.5C15.5029 14.5 15.1 14.0971 15.1 13.6V12.8612ZM27.2 18.8H12.8V22.5C12.8 23.4949 12.8007 24.187 12.8447 24.7255C12.8878 25.2535 12.9681 25.5541 13.0834 25.7804C13.3327 26.2696 13.7304 26.6673 14.2196 26.9166C14.446 27.0319 14.7465 27.1122 15.2745 27.1553C15.813 27.1993 16.5051 27.2 17.5 27.2H22.5C23.4949 27.2 24.187 27.1993 24.7255 27.1553C25.2535 27.1122 25.5541 27.0319 25.7804 26.9166C26.2696 26.6673 26.6673 26.2696 26.9166 25.7804C27.0319 25.5541 27.1122 25.2535 27.1553 24.7255C27.1993 24.187 27.2 23.4949 27.2 22.5V18.8Z"
          fill={theme.tokens.colors.accent.text.blue}
        />
      </g>
      <defs>
        <clipPath id="clip0_2950_59936">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(8 8)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
